/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import posthog from 'posthog-js'
import {POSTHOG_ENABLED, POSTHOG_HOST, POSTHOG_KEY} from 'helpers/config'

const shouldInit =
    POSTHOG_ENABLED && !(window as Window & { Cypress?: unknown }).Cypress

if (shouldInit) {
    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
    })
}

export default posthog
